import { RouteRecordRaw } from 'vue-router'
const Login = () =>
  import(/* webpackChunkName: "login-view" */ './pages/Login.vue')
const PasswordRecoveryRequest = () =>
  import(
    /* webpackChunkName: "login-view" */ './pages/PasswordRecoveryRequest.vue'
  )
const PasswordRecoveryConfirmation = () =>
  import(
    /* webpackChunkName: "login-view" */ './pages/PasswordRecoveryConfirmation.vue'
  )
const PasswordRecovery = () =>
  import(/* webpackChunkName: "login-view" */ './pages/PasswordRecovery.vue')

const PasswordRecoverySuccess = () =>
  import(
    /* webpackChunkName: "login-view" */ './pages/PasswordRecoverySuccess.vue'
  )

export const authModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Sign in',
    },
  },
  {
    path: 'password-recovery-request',
    name: 'PasswordRecoveryRequest',
    component: PasswordRecoveryRequest,
  },
  {
    path: 'password-recovery-confirmation',
    name: 'passwordRecoveryConfirmation',
    component: PasswordRecoveryConfirmation,
  },
  {
    path: 'password-recovery/:token',
    name: 'PasswordRecovery',
    component: PasswordRecovery,
  },
  {
    path: 'password-recovery-success',
    name: 'passwordRecoverySuccess',
    component: PasswordRecoverySuccess,
  },
]
